// Before adding a new URL to this file, please check
// if it is possible to disable it in config service
export const BANNED_URLS = [
  '/c/customer-service',
];

// Only the legacy compatibility check uses these. Everywhere else the page type
// comes from getCanonicalPageType(), whose vocabulary is the site's own.
export const PAGE_TYPES = {
  HOME: 'HOME',
  CONTENT: 'CONTENT',
  PIP: 'PIP',
  BROWSE: 'BROWSE',
  SEARCH: 'SEARCH',
  BIP: 'BIP',
  UNKNOWN: 'UNKNOWN',
};

// The FAB used to auto-expand on an allowlist of five page types, one of which
// ('browse') no live page ever reports. With the assistant on every nucleus page
// and an open-ended page-type vocabulary, an allowlist silently stops matching
// whenever an experience ships a new value, so this is a denylist instead.
export const FAB_EXPAND_DENYLIST = [
  'cart',
  'checkout',
  'checkout: opc',
];

// Page types where the page is still settling when the assistant mounts, so the
// expand waits longer.
export const EXTENDED_DELAY_PAGE_TYPES = [
  'pip',
  'bip',
  'ppip',
  'plp',
  'category',
  'search results',
];

export const OPEN_TYPES = {
  FAB_OPEN: 'FAB_OPEN',
  FAB_CLOSE: 'FAB_CLOSE',
  DEFAULT_MINIMIZED: 'DEFAULT_MINIMIZED',
  DEFAULT_OPEN: 'DEFAULT_OPEN',
  QUESTION_OPEN: 'QUESTION_OPEN',
  UNKNOWN: 'unknown'
};

export const MAGIC_APRON_CONTAINER_ID = 'DEF_MagicApronLoader';
export const MAGIC_APRON_ASSISTANT_ORIGIN = 'maa';

// Header entry point (MAG4-859). On the replaying lifeCycle bus so the header can
// subscribe at any point in page load; messages carry absolute state because a replayed
// toggle would desynchronise the drawer. Contract documented in the README.
// Header -> loader. { drawerState }
export const UPDATE_DRAWER_STATE = 'magic-apron-assistant.update-drawer-state';

export const HEADER_ENTRY = {
  // Loader -> header. { available, drawerState }
  STATUS_EVENT: 'magic-apron-assistant.header-entry-status',
  // A header click reports as the assistant's own submit-click. The three below fill its
  // `question`: maa:header:<page type>:prepopulated:ask magic apron clicked
  SUBMIT_EVENT: 'magic-apron-assistant.submit-click',
  // Analytics vocabulary. Kept separate from ORIGIN_HEADER, an internal routing token, so a
  // rename there cannot rewrite a reported string.
  ENTRY_LOCATION: 'header',
  MESSAGE_ORIGIN: 'prepopulated',
  QUESTION_LABEL: 'ask magic apron clicked',
  ORIGIN_HEADER: 'header',
  ORIGIN_FAB: 'fab',
};
